import { Icon as KdsIcon } from '@kizen/kds/Icon';
import { getFilePath } from 'pages/Marketplace/components/Tile/index';

interface PluginIconProps {
  thumbnail?: string | null;
  height?: number;
  marginBottom?: number;
}

export const PluginIcon = ({
  thumbnail,
  height = 40,
  marginBottom = 8,
}: PluginIconProps) => (
  <div
    className="kds flex items-center justify-center"
    style={{ height: `${height}px`, marginBottom: `${marginBottom}px` }}
  >
    {thumbnail ? (
      <img
        className="kds max-h-full object-contain"
        src={getFilePath(thumbnail)}
        alt=""
      />
    ) : (
      <KdsIcon icon="custom-puzzle-piece" />
    )}
  </div>
);
